<template>
  <el-row class="Content">
    <el-col :span="24">
      <div>
        <h4>{{ publicList.title }}</h4>
        <div class="hxl_title"></div>
        <p class="headerP">{{ publicList.written }}</p>
        <p class="footerP">{{ publicList.careful }}</p>
      </div>
      <div class="head">{{ publicList.head }}</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="问题类型" prop="problemType">
          <el-select v-model="ruleForm.problemType" placeholder="请选择">
            <el-option label="页面链接失效" value="lj"></el-option>
            <el-option label="图片显示错误" value="xs"></el-option>
            <el-option label="页面内容有误" value="nr"></el-option>
            <el-option label="错别字" value="cbz"></el-option>
            <el-option label="其他" value="qt"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面地址" prop="address">
          <el-input
            v-model="ruleForm.address"
            placeholder="如：http://gl.ncha.gov.cn/"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容标题" prop="title">
          <el-input
            v-model="ruleForm.title"
            placeholder="请输入内容标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题描述" prop="describe">
          <el-input
            type="textarea"
            v-model="ruleForm.describe"
            placeholder="请填写问题描述，请勿填写身份证号，银行卡、在线支付账号、密码等涉及用户隐私的信息，字数不要超过500字！"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="dialogImageUrl">
          <el-upload
            :action="urlOne + '/api/uploadFileStore'"
            list-type="picture-card"
            :data="uploadData"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :file-list="ruleForm.imageList"
          >
            <i class="el-icon-plus"></i>
            <div class="el-upload__tip" slot="tip">只能上传jpg/jpeg/png文件，且不超过100MB</div>
          </el-upload>
          <el-dialog :visible.sync="ruleForm.dialogVisible">
            <img width="100%" :src="ruleForm.dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="您的姓名" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入您的姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input
            v-model="ruleForm.tel"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verification">
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="ruleForm.verification"
                placeholder="请输入验证码"
              ></el-input>
            </el-col>
            <el-col :span="7">
              <v-sidentify @total="createdCode"></v-sidentify>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            class="tijiao"
            @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button class="chongz" @click="resetForm('ruleForm')"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>
<script>
import Sidentify from "../../components/SIdentify/SIdentify";
import util from "../../utils/util";
export default {
  props: [],
  components: { "v-sidentify": Sidentify },
  data() {
    return {
      // 上方区域
      publicList: {
        //    标题
        title: "国家文物局综合行政管理平台系统建议",
        written:
          "欢迎将您在使用过程中对系统的意见和建议反馈给我们！您的意见和建议对我们非常重要，我们将认真研究，不断推动系统的功能优化和迭代升级，为您提供更好的服务。 感谢您的关注和支持！",
        careful: "此处只处理系统自身功能、性能和内容等方面的相关问题。",
        head: "信息填写",
      },
      created: "",
      // 身份证扫描件
      uploadData: {
        file: "",
        BId: "",
        fileType: "",
        storeType: "",
      },
      bids: "",
      urlOne: "",
      ruleForm: {
        describe: "",
        address: "",
        title: "",
        problemType: "",
        name: "",
        tel: "",
        dialogImageUrl: [],
        dialogVisible: false,
        imageList: [],
        verification: "",
        id: "",
      },
      rules: {
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入页面地址", trigger: "blur" },
        ],
        problemType: [
          { required: true, message: "请输入问题类型", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入内容标题", trigger: "blur" }],
        describe: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入您的名字", trigger: "blur" }],
        // tel: [{ required: true, message: "请输入您的电话", trigger: "blur" }],
        tel: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          {
            type: "number",
            message: "请填写正确的手机号",
            trigger: "blur",
            transform(value) {
              var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
              if (!myreg.test(value)) {
                return false;
              } else {
                return Number(value);
              }
            },
          },
        ],
        imageList: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  methods: {
    createdCode(e) {
      this.created = e.toLowerCase();
    },
    //  表单提交重置
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let verification = this.ruleForm.verification.toLowerCase();
          if (this.created !== verification) {
            this.$message.error("验证码输入错误");
            return;
          }
          this.ruleForm.id = this.bids;
          let Url = util.getAjaxUrl("axiosThree");
          this.$http
            .post(Url + "/api/sys/cmsSysSuggests", this.ruleForm)
            .then((res) => {
              if (res.status == 201) {
                this.$message.success("提交成功");
                this.ruleForm = {};
                this.$refs["ruleForm"].resetFields();
              }
            });
        } else {
          return false;
        }
      });
    },
    //获取Bid
    getBid() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/api/common/getId").then((res) => {
        if (res.status == 200) {
          this.bids = res.data;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.imageList = [];
    },
    // 图片上传
    handleRemove(file, fileList) {
      this.ruleForm.imageList = fileList;
      this.$refs.ruleForm.validateField(this.ruleForm.imageList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
      const isLt100M = file.size < 1024*1024*100;
      if (!isJPG) {
        this.$message.error('请上传图片!');
        return false
      }
      if(!isLt100M) {
        this.$message.error('上传图片大小不能超过100MB!');
        return false
      }
      this.uploadData = {
        file: file.name,
        BId: this.bids,
        fileType: "picture",
        storeType: "0",
      };
      return new Promise((resolve, reject) => {
        this.$nextTick(function () {
          resolve(true);
        });
      });
      //  return promise
    },
    handleSuccess(file, fileList) {
      let obj = {};
      obj.name = fileList.name;
      obj.url = fileList.url;
      this.ruleForm.imageList.push(obj);
      this.$refs.ruleForm.validateField(this.ruleForm.imageList);
    },
  },
  mounted() {
    this.getBid();
    this.urlOne = util.getAjaxUrl("axiosOne");
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/comSty";

/deep/.el-upload--picture-card:hover,
.el-upload:focus {
  border-color: #b71c1c;
  color: #b71c1c;
}

/deep/.el-textarea__inner {
  min-height: 126px;
  height: 126px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

.Content {
  width: 70%;
  margin: 0 auto;
  padding-top: 30px;
}

/deep/.el-input--suffix .el-input__inner {
  height: 40px;
}

h4 {
  font-size: 22px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}

.tijiao {
  background-color: #b71c1c;
  padding: 10px 40px;
  margin-right: 40px;
}

.chongz {
  padding: 10px 40px;
}

.chongz:focus {
  color: #b71c1c;
}

.chongz:hover {
  color: #b71c1c;
  border-color: #b71c1c;
}

.headerP {
  line-height: 22px;
  font-size: 15px;
  padding-left: 10px;
}

.footerP {
  line-height: 22px;
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
}

.head {
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  padding: 10px;
  margin: 10px 0;
  background-color: #f2f2f2;
}

.verify_css {
  width: 45%;
}

#v_container {
  width: auto;
  height: auto;
  display: inline-flex;
  position: relative;
  top: 1rem;
  margin-top: -2rem;
}
</style>